import React, {Component} from 'react'
import ReactTable from 'react-table'
import {Query, SubscriptionWrapper} from 'react-apollo'
import Router from 'next/router'
import {debounce} from 'lodash'
import {withRouter} from "react-router-dom"
import 'react-table/react-table.css'

import AUSelectGenerator from '../auto_updaters/Select'
import QUERY from '../../../queries/server/filter_projects'
import SUBSCRIPTION from '../../../queries/server/subscriptions/project_upserted'

const AUSelectProjectStatuses = AUSelectGenerator('project_statuses', 'project_status_id description', 'project_status_id', ['description'])
const AUSelectUsers = AUSelectGenerator('users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'])

class ProjectsList extends Component {

    componentDidMount() {
        this.props.subscribeToUpsert()
    }

    render() {
        return (<ReactTable
            data={this.props.projects}
            loading={this.props.loading}
            style={{display: 'flex', flex: 1, fontSize: '14px'}}
            pageSizeOptions={[5, 10, 20, 25, 50, 100, this.props.totalProjects]}
            columns={[
                {
                    Header: "Project ID",
                    id: 'project_id',
                    accessor: 'project_id'
                },
                {
                    Header: "Name",
                    id: 'name',
                    accessor: 'name'
                },
                {
                    Header: "Status",
                    id: 'project_status_id',
                    accessor: "project_status.description",
                    Filter: ({filter, onChange}) => {
                        return <AUSelectProjectStatuses className="form-control-sm" value={(filter) ? filter.value : null} onChange={onChange}/>
                    }
                },
                {
                    Header: "Clients",
                    id: "project_clients",
                    accessor: "project_clients",
                    filterable: true,
                    Cell: row => (
                        <div>
                            {row.value.map(({client}) => <div>{client.name}</div>)}
                        </div>
                    )
                },
                {
                    Header: "Director",
                    id: 'project_director_id',
                    accessor: ({project_director}) => (project_director) ? `${project_director.first_name} ${project_director.last_name}` : '',
                    Filter: ({filter, onChange}) => {
                        return <AUSelectUsers className="form-control-sm" value={(filter) ? filter.value : null} onChange={onChange}/>
                    }
                },
                {
                    Header: "Lead Engineer",
                    id: 'project_manager_id',
                    accessor: ({project_manager}) => (project_manager) ? `${project_manager.first_name} ${project_manager.last_name}` : '',
                    Filter: ({filter, onChange}) => {
                        return <AUSelectUsers className="form-control-sm" value={(filter) ? filter.value : null} onChange={onChange}/>
                    }
                }

            ]}
            className="-striped -highlight"
            onFetchData={debounce((state, instance) => this.props.onFetchData(state, instance), 500, {
                leading: true,
                trailing: false
            })} // Request new data when things change
            filterable
            manual
            showPagination={true}
            pages={this.props.pages}
            getTrProps={(state, rowInfo) => {
                return {
                    onClick: (e) => {
                        const projectUrl = `${window.location.origin}/projects/${rowInfo.original.project_id}`
                        const user = sessionStorage.getItem('user')
                        const newWindow = window.open('about:blank', '_blank')

                        if (!newWindow) {
                            this.props.history.push(`/projects/${rowInfo.original.project_id}`)
                            return
                        }

                        if (user) {
                            newWindow.sessionStorage.setItem('user', user)
                        }

                        newWindow.location.href = projectUrl
                    }
                }
            }}
        />)
    }
}

ProjectsList = withRouter(ProjectsList)

export default class ProjectsTable extends Component {

    state = {
        project_id: '',
        name: '',
        project_status_id: null,
        project_director_id: null,
        project_manager_id: null,
        project_clients: null,
        limit: 10,
        offset: 0
    }

    fetchData = (state, instance) => {

        console.log('filter', state.pageSize, state.page)

        let filters = state.columns.reduce((carry, column) => {
            if (column.hasOwnProperty('id')) {
                const filterValue = state.filtered.find(({id}) => id === column.id)
                carry[column.id] = (filterValue) ? filterValue.value : ''
            }
            return carry
        }, {})

        this.setState(Object.assign({}, filters, {limit: state.pageSize, offset: state.pageSize * state.page}))
    }

    render() {

        const {project_id, name, project_status_id, project_director_id, project_manager_id, project_clients, limit, offset} = this.state
        return (<Query query={QUERY} fetchPolicy="network-only" variables={{
            project_id,
            name,
            project_status_id,
            project_director_id,
            project_manager_id,
            project_clients,
            limit,
            offset
        }}>
            {(result) => {

                const projects = (result.data && result.data.filter_projects) ? result.data.filter_projects : []

                return (
                    <ProjectsList
                        loading={result.loading}
                        projects={projects}
                        pages={Math.ceil(result.data.total_projects / limit)}
                        totalProjects={result.data.total_projects}
                        onFetchData={this.fetchData}
                        subscribeToUpsert={() => {
                            return result.subscribeToMore(
                                {
                                    document: SUBSCRIPTION,
                                    variables: {
                                        project_id,
                                        name,
                                        project_status_id,
                                        project_director_id,
                                        project_manager_id,
                                        project_clients
                                    },
                                    updateQuery: (prev, {subscriptionData}) => {

                                        if (!subscriptionData.data) {
                                            return prev
                                        }

                                        let data = {}

                                        //does the record already exist using the uniqueKey
                                        const existingRecordIndex = prev.filter_projects.findIndex(data => data.project_id === subscriptionData.data.projectsUpserted.project_id)

                                        if (existingRecordIndex !== -1) {
                                            data['filter_projects'] = [
                                                ...prev.filter_projects.slice(0, existingRecordIndex),
                                                {...subscriptionData.data.projectsUpserted},
                                                ...prev.filter_projects.slice(existingRecordIndex + 1)
                                            ]
                                        }
                                        else {
                                            data['filter_projects'] = [...prev.filter_projects, subscriptionData.data.projectsUpserted]
                                        }


                                        return data
                                    }
                                }
                            )
                        }}/>

                )
            }}
        </Query>)
    }

}